<template>
  <router-view />
  <ConsentBanner />
</template>

<script setup lang="ts">
import ConsentBanner from '@/components/ConsentBanner.vue'
</script>
